
/**
 *
 */

+function($){

  page.initDrawer = function() {

    $(document).on( 'click', '.drawer-toggler, .drawer-close, .backdrop-drawer', function() {
      $('body').toggleClass( 'drawer-open' );
    });

  }

}(jQuery);




//////////////////
// WEBPACK FOOTER
// ./assets/plugin/thesaas/js/partials/drawer.js
// module id = 67
// module chunks = 0